import React from 'react';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';

import useWidgetStream from 'widgets/streaming/useWidgetStream';

import { usePortfolioStreamedOrSelectedPositionFromOrders } from 'portfolio/store/hooks';
import InfoBox from 'utils/components/InfoBox/InfoBox';

import './OrderFillsCapsule.scss';
import { orderFillsCapsuleStreamedDataSelectors } from '../store/streamSlice';
import OrderFillsCapsuleSettings from './OrderFillsCapsuleSettings';
import { OrderFillsCapsuleContent } from './OrderFillsCapsuleContent';
import { useOrderFillsCapsuleStrategy } from '../orderFillsCapsuleStrategy';
import { IconTooltip } from 'utils/components/IconTooltip';
import { useWarningForOrderDependentCapsules } from '../../../../tiles/components/tile/hooks';

export function OrderFillsCapsule() {
    const { useWidgetMessages } = orderFillsCapsuleStreamedDataSelectors;
    const { title, helpText } = useOrderFillsCapsuleStrategy();

    const position = usePortfolioStreamedOrSelectedPositionFromOrders();

    const messages = useWidgetMessages();

    useWidgetStream();

    const warning = useWarningForOrderDependentCapsules();

    const chartData = {};
    return (
        <WidgetTile className="OrderFillsCapsule">
            <TileToolbar
                title={title}
                settingsBody={<OrderFillsCapsuleSettings />}
                settingsHeader={`${title} Settings`}
                settingsClassName="OrderFillsCapsuleSettingsModal"
                preceedingItems={
                    <IconTooltip>
                        <div>{helpText}</div>
                    </IconTooltip>
                }
                messages={position ? messages : []}
                wideTitle={true}
            />

            <div className="capsule-body">
                {warning && <InfoBox info={warning} />}
                {!warning && !chartData && <>No data</>}
                {!warning && chartData && <OrderFillsCapsuleContent />}
            </div>
        </WidgetTile>
    );
}
